import { BaseApi } from 'src/api/BaseApi';
import { DEMO_OUTLETS, DEMO_ALL_OUTLETS } from 'src/api/demo/outlets';

class OutletApi extends BaseApi {
  async fetchAllOutlets() {
    if (this.isDemo()) return DEMO_ALL_OUTLETS;

    const response = await this.postRequest('queries/outlets');
    return response.data;
  }

  async fetchOutlets() {
    if (this.isDemo()) return DEMO_OUTLETS;

    const response = await this.postRequest('outlets');
    return response.data;
  }

  async submitOutlet(outlet, type) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id: Date.now(),
        outlet: { id: Date.now(), outlet, type, createdAt: new Date().toISOString() },
      });
    }

    const formData = this.createFormData({
      outlet,
      type,
    });

    const response = await this.postRequest('outlets/submit', formData);
    return response.data;
  }

  async updateOutlet(id, outlet, type) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id,
        outlet: { id, outlet, type },
      });
    }

    const formData = this.createFormData({
      id,
      outlet,
      type,
    });

    const response = await this.postRequest('outlets/update', formData);
    return response.data;
  }

  async deleteOutlet(id) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id,
        deleted: true,
      });
    }

    const formData = this.createFormData({
      id,
    });

    const response = await this.postRequest('outlets/delete', formData);
    return response.data;
  }
}

export const outletApi = new OutletApi();

